import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Drawer,
  Grid,
  List,
  ListItem,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
//アイコン
import NotesIcon from "@mui/icons-material/Notes";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import FastfoodIcon from "@mui/icons-material/Fastfood";
import DailySummary from "./DailySummary";
import { formatScore } from "../utils/formatting";
import IconComponents from "./common/IconComponents";
const TransactionMenu = ({
  dailyTransactions,
  currentDay,
  onAddTransactionForm,
  onSelectTransaction,
}) => {
  const menuDrawerWidth = 320;
  return (
    <Drawer
      sx={{
        width: menuDrawerWidth,
        "& .MuiDrawer-paper": {
          width: menuDrawerWidth,
          boxSizing: "border-box",
          p: 2,
          top: 64,
          height: `calc(100% - 64px)`, // AppBarの高さを引いたビューポートの高さ
        },
      }}
      variant={"permanent"}
      anchor={"right"}
    >
      <Stack sx={{ height: "100%" }} spacing={2}>
        <Typography fontWeight={"fontWeightBold"}>
          日時： {currentDay}
        </Typography>
        <DailySummary dailyTransactions={dailyTransactions} />
        {/* 内訳タイトル&内訳追加ボタン */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 1,
          }}
        >
          {/* 左側のメモアイコンとテキスト */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <NotesIcon sx={{ mr: 1 }} />
            <Typography variant="body1">内訳</Typography>
          </Box>
          {/* 右側の追加ボタン */}
          <Button
            startIcon={<AddCircleIcon />}
            color="primary"
            onClick={onAddTransactionForm}
          >
            内訳を追加
          </Button>
        </Box>

        {/* ワークアウト一覧 */}
        <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
          <List aria-label="取引履歴">
            <Stack spacing={2}>
              {dailyTransactions.map((transaction, index) => (
                <ListItem disablePadding key={index}>
                  <Card
                    sx={{
                      width: "100%",
                      backgroundColor: (theme) => {
                        return theme.palette[transaction.category]?.light;
                      },
                    }}
                    onClick={() => onSelectTransaction(transaction)}
                  >
                    <CardActionArea>
                      <CardContent>
                        <Grid
                          container
                          spacing={1}
                          wrap="wrap"
                          sx={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Grid size={2}>
                            {/* icon */}
                            {IconComponents[transaction.category]}
                          </Grid>
                          <Grid size={3}>
                            <Typography
                              variant="caption"
                              display="block"
                              gutterBottom
                              noWrap
                            >
                              {transaction.category}
                            </Typography>
                          </Grid>
                          <Grid size={4.5}>
                            <Typography variant="body2" gutterBottom noWrap>
                              {transaction.exercise}
                            </Typography>
                          </Grid>
                          <Grid size={2.5}>
                            <Typography
                              gutterBottom
                              color="text.secondary"
                              noWrap
                              sx={{
                                textAlign: "right",
                                wordBreak: "break-all",
                              }}
                            >
                              {formatScore(transaction.total_score)}pt
                            </Typography>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </ListItem>
              ))}
            </Stack>
          </List>
        </Box>
      </Stack>
    </Drawer>
  );
};
export default TransactionMenu;
